// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteReasonForLeavingMutationVariables = Types.Exact<{
  deleteReasonForLeavingId: Types.Scalars['ID']['input'];
}>;

export type DeleteReasonForLeavingMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deleteReasonForLeaving'
>;

export const DeleteReasonForLeavingDocument = /*#__PURE__*/ gql`
    mutation DeleteReasonForLeaving($deleteReasonForLeavingId: ID!) {
  deleteReasonForLeaving(id: $deleteReasonForLeavingId)
}
    `;
export type DeleteReasonForLeavingMutationFn = Apollo.MutationFunction<
  DeleteReasonForLeavingMutation,
  DeleteReasonForLeavingMutationVariables
>;

/**
 * __useDeleteReasonForLeavingMutation__
 *
 * To run a mutation, you first call `useDeleteReasonForLeavingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReasonForLeavingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReasonForLeavingMutation, { data, loading, error }] = useDeleteReasonForLeavingMutation({
 *   variables: {
 *      deleteReasonForLeavingId: // value for 'deleteReasonForLeavingId'
 *   },
 * });
 */
export function useDeleteReasonForLeavingMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteReasonForLeavingMutation, DeleteReasonForLeavingMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteReasonForLeavingMutation, DeleteReasonForLeavingMutationVariables>(
    DeleteReasonForLeavingDocument,
    options,
  );
}
export type DeleteReasonForLeavingMutationHookResult = ReturnType<typeof useDeleteReasonForLeavingMutation>;
export type DeleteReasonForLeavingMutationOptions = Apollo.BaseMutationOptions<
  DeleteReasonForLeavingMutation,
  DeleteReasonForLeavingMutationVariables
>;
